import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PresentationPreviewPage } from '../features/presentations/presentation-preview-page';

const SearchSchema = z.object({ slide: z.string().optional() });

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview',
)({
  component: RouteComponent,
  validateSearch: SearchSchema,
});

function RouteComponent() {
  const params = Route.useParams();
  const { slide } = Route.useSearch();
  return <PresentationPreviewPage {...params} slideId={slide} />;
}
